import { z } from 'zod';

export const ReversePaywallMonthlyPrefixLiterals = z.enum(['only', 'equivalent']);
export const ViewAllPlansColorLiterals = z.enum(['neutral.400', 'primary.200', 'neutral.500', 'primary.400']);
export type ViewAllPlansColorLiterals = z.infer<typeof ViewAllPlansColorLiterals>;

export type ReversePaywallMonthlyPrefixLiterals = z.infer<typeof ReversePaywallMonthlyPrefixLiterals>;

export const SubscriptionPeriodLiterals = z.enum(['P1D', 'P1W', 'P1M', 'P3M', 'P6M', 'P1Y']);
export type SubscriptionPeriodLiterals = z.infer<typeof SubscriptionPeriodLiterals>;
